<fieldset class="checkbox-form-group">
  <legend>{{ label ?? "Group Options" }}</legend>
  <br />
  <ng-container *ngIf="options?.length > 1 && selectAllEnabled">
    <button
      *ngIf="!showDeselectAll"
      type="button"
      class="semantic-button select-all-link"
      [attr.aria-label]="'Select all ' + (label ?? 'Group Options')"
      (click)="selectAll()"
    >
      Select All
    </button>
    <button
      *ngIf="showDeselectAll"
      type="button"
      class="semantic-button select-all-link"
      [attr.aria-label]="'Deselect all ' + (label ?? 'Group Options')"
      (click)="deselectAll()"
    >
      Deselect All
    </button>
  </ng-container>
  <ciao-form-field
    *ngFor="let option of options"
    [label]="option.label"
    type="checkbox"
    [formControlInput]="control.controls[option.value]"
    [badgePerson]="option.badgePerson"
  />
  <!-- {{ control.errors | json }}
  {{ errors | json }}
  {{ valid | json }} -->
</fieldset>
